const FuncionalidadesNome = Object.freeze({
  // Grupo / Usuário
  CriarGrupoDeUsuario: "CriarGrupoDeUsuario",
  CriarUsuario: "CriarUsuario",
  CriarAluno: "CriarAluno",
  EditarAluno: "EditarAluno",
  DeletarAluno: "DeletarAluno",
  CriarMonitor: "CriarMonitor",
  DeletarMonitor: "DeletarMonitor",
  EditarMonitor: "EditarMonitor",
  VisualizarMonitores: "VisualizarMonitores",
  RestaurarMonitor: "RestaurarMonitor",
  EditarCoordenadores: "EditarCoordenadores",

  // Avisos
  AcessoAoAviso: "AcessoAoAviso",
  ModalAdicionarAvisosMonitor: "ModalAdicionarAvisosMonitor",
  ModalAdicionarAvisosCoordenador: "ModalAdicionarAvisosCoordenador",

  // Leads
  DeletarLead: "DeletarLead",

  // Turmas
  CriarTurma: "CriarTurma",
  ExcluirTurma: "ExcluirTurma",
  AtualizarTurma: "AtualizarTurma",
  CriarPessoaTurma: "CriarPessoaTurma",
  ExcluirPessoaTurma: "ExcluirPessoaTurma",

  // Eventos
  CriarEvento: "CriarEvento",
  ExcluirEvento: "ExcluirEvento",
  AtualizarEvento: "AtualizarEvento",
  VisualizarEventos: "VisualizarEventos",

  // Suporte
  ResponderSuporte: "ResponderSuporte",
  AdicionarSuporte: "AdicionarSuporte",
  RemoverSuporte: "RemoverSuporte",

  // Documentos
  CriarDocumento: "CriarDocumento",
  ExcluirDocumento: "ExcluirDocumento",
  VisualizarDocumento: "VisualizarDocumento",

  // Fotos
  CarregarFoto: "CarregarFoto",
  VisualizarFoto: "VisualizarFoto",

  // Alunos
  AtualizarDadosAlunos: "AtualizarDadosAlunos",
  ExibirDadosAlunos: "ExibirDadosAlunos",

  // Frequência / Certificados
  AdicionarFrequencia: "AdicionarFrequencia",
  EmitirCertificado: "EmitirCertificado",

  // Sidebar
  ExibirItensSidebar: "ExibirItensSidebar",
  ExibirItemSidebarAlunos: "ExibirItemSidebarAlunos",
  ExibirItemSidebarTurmas: "ExibirItemSidebarTurmas",
  ExibirItemSidebarAvaliacoes: "ExibirItemSidebarAvaliacoes",
  ExibirItemSidebarAvisos: "ExibirItemSidebarAvisos",
  ExibirItemSidebarDocumentos: "ExibirItemSidebarDocumentos",
  ExibirItemSidebarSuporte: "ExibirItemSidebarSuporte",
  ExibirItemSidebarCalendario: "ExibirItemSidebarCalendario",
  ExibirItemSidebarFrequencia: "ExibirItemSidebarFrequencia",
  ExibirItemSidebarCertificados: "ExibirItemSidebarCertificados",

  // Topbar
  ExibirItemTopbarAtalhoFrequencia: "ExibirItemTopbarAtalhoFrequencia",

  // Avaliações
  VizualizarAvaliacao: "VizualizarAvaliacao",

  // Outros
  PermissaoChat: "PermissaoChat",
});

export default FuncionalidadesNome;
